module.exports = "./img/07f2cb7516d254cbc1a5b5ee0a237a6b.png";